import React from 'react';

const Loader = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="relative w-16 h-16 mb-4">
        <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-200 dark:border-indigo-900 rounded-full opacity-25"></div>
        <div className="absolute top-0 left-0 w-full h-full border-4 border-indigo-600 dark:border-indigo-500 rounded-full border-t-transparent animate-spin"></div>
      </div>
      <h3 className="text-lg font-semibold text-slate-700 dark:text-slate-200">Broadcasting Request...</h3>
      <p className="text-sm text-slate-500 dark:text-slate-400 mt-2 animate-pulse">Matching with top-rated providers</p>
    </div>
  );
};

export default Loader;